<ng-container *transloco="let t">
  <ld-base-modal [title]="t('commonTcpaEconsentDisclosureTitle')" [size]="'large'" (closeModal)="closeModal.emit()">
    <div modal-content>
      <div class="p-6 max-h-[60vh] overflow-y-auto">
        <div class="font-dm text-sm text-ld-neutral leading-relaxed space-y-4">
          <p id="ecomm-intro">
            {{ t('modalsElectronicCommunicationsIntro') }}
          </p>

          <p id="ecomm-paper-right">
            {{ t('modalsElectronicCommunicationsPaperRight') }}
          </p>

          <p id="ecomm-withdraw">
            {{ t('modalsElectronicCommunicationsWithdraw') }}
          </p>

          <p id="ecomm-scope">
            {{ t('modalsElectronicCommunicationsScope') }}
          </p>

          <p id="ecomm-confirm">
            {{ t('commonButtonsConfirm') }}
          </p>

          <p id="ecomm-requirements-intro">
            {{ t('modalsElectronicCommunicationsRequirementsIntro') }}
          </p>

          <ul id="ecomm-requirements-list" class="list-disc pl-6 space-y-2">
            <li>{{ t('modalsElectronicCommunicationsRequirementsDevice') }}</li>
            <li>{{ t('modalsElectronicCommunicationsRequirementsBrowser') }}</li>
            <li>{{ t('modalsElectronicCommunicationsRequirementsInternet') }}</li>
            <li>{{ t('modalsElectronicCommunicationsRequirementsStorage') }}</li>
            <li>{{ t('modalsElectronicCommunicationsRequirementsEmail') }}</li>
            <li>{{ t('modalsElectronicCommunicationsRequirementsSoftware') }}</li>
          </ul>

          <p id="ecomm-acceptance">
            {{ t('modalsElectronicCommunicationsAcceptance') }}
          </p>
        </div>
      </div>
    </div>
    <div modal-footer>
      <button id="electronic-comms-back-btn" type="button" class="btn-primary-ld-purple" (click)="onBack()">
        {{ t('commonButtonsBack') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
